import ReactAppContainer from "@iloq/shared-react/ReactAppContainer";
import { VueContextType } from "@iloq/shared-react/vueContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Fragment, ReactElement } from "react";
import { IntlProvider } from "react-intl";
import { HeroPartner } from "./hero-partner";

// TODO: Eventually we'll want to share the query client & provider between all the apps
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /* If a user leaves your application and returns and the query data is stale, 
      TanStack Query automatically requests fresh data for you in the background. 
      You can disable this globally or per-query using the refetchOnWindowFocus option: */
      refetchOnWindowFocus: false, // default: true
      retry: false,
      staleTime: 1000 * 60 * 30, // 30 mins cache
    },
  },
});

export default function HeroProviderPartner(props: VueContextType): ReactElement {
  return (
    <ReactAppContainer vueProps={props}>
      <QueryClientProvider client={queryClient}>
        <IntlProvider
          locale={props.locale}
          messages={props.messages[props.locale]}
          textComponent={Fragment}
        >
          <HeroPartner />
        </IntlProvider>
      </QueryClientProvider>
    </ReactAppContainer>
  );
}
